import { EnvironmentProviders, inject, makeEnvironmentProviders, provideEnvironmentInitializer } from '@angular/core';

import { FaConfig, FaIconLibrary } from '@fortawesome/angular-fontawesome';

import {
  brandsSvgIconsPack,
  bunnyFaIconPack,
  freeBrandsSvgIconsPack,
  proDualToneSvgIconsPack,
  proRegularSvgIconsPack,
  proSolidSvgIconsPack,
} from './fa-icon-packs';

export function provideFontawesome(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideEnvironmentInitializer((): void => {
      const faLib = inject(FaIconLibrary);
      const faConfig = inject(FaConfig);

      faConfig.defaultPrefix = 'fas';

      // Add custom Bunny font pack + slimmed FA icons packs.
      faLib.addIconPacks(proSolidSvgIconsPack, brandsSvgIconsPack, freeBrandsSvgIconsPack, proDualToneSvgIconsPack, proRegularSvgIconsPack, bunnyFaIconPack);
    }),
  ]);
}
